import React, { useState } from 'react';
import '../styles/settings/AdminSettingsPage.css';
import '../styles/settings/SalesPopupPage.css';
import SalesPopupConfigForm from '../components/AdminSalesPopupPage/SalesPopupConfigForm';
import SalesPopupStatistics from '../components/AdminSalesPopupPage/SalesPopupStatistics';

const AdminSalesPopupPage = () => {
  const [activeTab, setActiveTab] = useState('configuration'); // 'configuration' or 'statistics'

  return (
    <div className="admin-settings-page admin-settings-page--no-padding">
      <div className="admin-settings-page__intro">
        <h1>Sales Popup</h1>
      </div>
      <div className="admin-settings-page__settings">
        <div className="sales-popup-tabs">
          <button
            className={`sales-popup-tab ${activeTab === 'configuration' ? 'active' : ''}`}
            onClick={() => setActiveTab('configuration')}
          >
            Configuration
          </button>
          <button
            className={`sales-popup-tab ${activeTab === 'statistics' ? 'active' : ''}`}
            onClick={() => setActiveTab('statistics')}
          >
            Statistics
          </button>
        </div>
        <div className="sales-popup-content">
          {activeTab === 'configuration' && <SalesPopupConfigForm />}
          {activeTab === 'statistics' && <SalesPopupStatistics />}
        </div>
      </div>
    </div>
  );
};

export default AdminSalesPopupPage;

